import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import Cta from '~/components/atoms/Cta.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import RegularSubtitle from '~/components/atoms/Global/RegularSubtitle.vue';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import { SELF_TARGET } from '~/const/button';
var COLORS = {
  grey: 'primary',
  transparent: 'transparent'
};
export default {
  components: {
    RegularTitle: RegularTitle,
    RegularSubtitle: RegularSubtitle,
    SimpleParagraph: SimpleParagraph,
    Cta: Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function title() {
      return {
        text: this.payload.primary.title.length ? this.payload.primary.title[0].text : '',
        color: this.payload.primary.title_color || '',
        level: this.payload.primary.title.length ? this.payload.primary.title[0].type : ''
      };
    },
    target: function target() {
      return SELF_TARGET;
    },
    subtitle: function subtitle() {
      return {
        text: this.payload.primary.subtitle.length ? this.payload.primary.subtitle[0].text : '',
        color: this.payload.primary.subtitle_color || '',
        level: this.payload.primary.subtitle.length ? this.payload.primary.subtitle[0].type : ''
      };
    },
    simpleParagraph: function simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    textAlignement: function textAlignement() {
      return "text-md-".concat(this.payload.primary.text_alignement);
    },
    ctas: function ctas() {
      if (!(this.payload.items && this.payload.items.length)) return [];
      var unemptyCtas = this.payload.items ? this.payload.items.filter(function (e) {
        return e.button_url && e.button_url.url && e.button_url.url.trim().length > 0 && e.button_text && e.button_text.trim().length > 0;
      }) : [];
      return unemptyCtas.map(function (item) {
        return {
          props: {
            url: item.button_url.url || '',
            svg: item.button_icon_name || '',
            textBtn: item.button_text || '',
            type: COLORS[item.button_color] || 'primary'
          },
          tracking: {
            data: {
              event_category: item.button_event_category || '',
              event_action: item.button_event_action || '',
              event_label: item.button_event_label || ''
            }
          }
        };
      });
    }
  }
};